module.exports = __webpack_public_path__ + "3111034e52fd9939eab1d7dc677d21fd.png";